import React from 'react';
import { Box, Button, Container, Typography } from '@material-ui/core';

const ResearchText = (props) => (
  <Box
    sx={{
      backgroundColor: 'background.paper',
      pt: 6
    }}
    {...props}
  >
    <Container
      maxWidth="md"
      sx={{
        alignItems: 'center',
        display: 'flex',
        flexDirection: 'column',
        px: {
          md: '130px !important'
        }
      }}
    >
      <Typography
        color="textSecondary"
        sx={{ mb: 2 }}
        variant="body1"
        align="justify"
      >
        <h3>Research</h3>
        Bei eyerena Research werten wir aktuelle Forschungserbnisse aus, um daraus unsere Übungen und Vorgehen zu optimieren.
        Wir möchten gerne unsere Recherchen mit Euch teilen.
        Wir freuen uns auch über jede weitere Quelle und Forschungsergebnisse von Euch.
        Je mehr wir über ViCo wissen, desto besser können wir ViCo nach vorne bringen und es unseren Schülern vermitteln.
        <br />
        <br />
        <br />
        A SUMMARY OF RESEARCH AND CLINICAL STUDIES ON VISION AND LEARNING
        <br />
        <Button
          style={{ display: 'flex', float: 'left' }}
          href="http://dynamic-eye.de/wp-content/uploads/2021/02/Summary-Forschungsergebnisse-Zusammenhang-Lesen-und-Lernen.pdf"
        >
          PDF Dokument auf dynamic-eye.de
        </Button>
        <br />
        <br />
        <br />
        Erfolg von optometrischen Verordnungen bei Kindern mit Lese-Rechtschreibproblemen
        <br />
        <Button
          style={{ display: 'flex', float: 'left' }}
          href="http://dynamic-eye.de/wp-content/uploads/2021/02/Iris-Weiskamp-Erfolg-von-optometrischen-Verordnungen-bei-Kindern-mit-Lese-Rechtschreibproblemen.pdf"
        >
          PDF Dokument auf dynamic-eye.de
        </Button>
        <br />
        <br />
        <br />
        Visuelle Wahrnehmungsleistungen bei Kindern mit Lese- Rechtschreibstörung
        <br />
        <Button
          style={{ display: 'flex', float: 'left' }}
          href="https://econtent.hogrefe.com/doi/abs/10.1024/1422-4917/a000353?journalCode=kij"
        >
          Artikel mit weiteren Links auf econtent.hogrefe.com
          <br />
        </Button>
        <br />
        <br />
        <br />
        Sehen - Welche Zusammenhänge gibt es zwischen Legasthenie und dem Sehen
        <br />
        <Button
          style={{ display: 'flex', float: 'left' }}
          href="http://www.legasthenie-info.de/sehen.html"
        >
          Artikel mit weiteren Links auf legasthenie-info.de
        </Button>
        <br />
        <br />
        <br />
        Sehen - Welche Zusammenhänge gibt es zwischen Legasthenie und dem Sehen
        <Button
          style={{ display: 'flex', float: 'left' }}
          href="https://www.optometrists.org/childrens-vision/vision-for-school/dyslexia/"
        >
          Artikel mit weiteren Links auf www.optometrists.org
        </Button>
      </Typography>
    </Container>
  </Box>
);
export default ResearchText;
